import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";

export class ListView extends Component {
  constructor(props) {
    super(props);
    const { data } = this.props;
    this.state = {
      data,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value) {
    const { data } = this.state;
    const { handleChange } = this.props;
    const currentIndex = data.indexOf(value);
    // eslint-disable-next-line no-param-reassign
    value.checked = !value.checked;
    const updatedArray = data.slice(); // creates the clone of the state
    updatedArray[currentIndex] = { ...value };
    this.setState({
      data: updatedArray,
    }, () => { handleChange(data); });
  }

  render() {
    const { data } = this.state;
    return (
      <List className="listWrapper">
        {data.map((value) => {
          const labelId = `checkbox-list-label-${value.busNumber}`;

          return (
            <ListItem
              key={value.busNumber}
              role={undefined}
              dense
              button
              onClick={() => { this.handleChange(value); }}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={value.checked}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.busNumber} />
              <ListItemText id={labelId} primary={value.operatorName} />

              <ListItemSecondaryAction />
            </ListItem>
          );
        })}
      </List>
    );
  }
}
